import { Component, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { News } from '../../../shared/interface';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-news-backoffice',
  templateUrl: './news-backoffice.component.html',
  styleUrl: './news-backoffice.component.css'
})
export class NewsBackofficeComponent {  

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild("deleteNews") deleteNews!: ConfirmPopup;

  notizie: News[] = []

  loading: boolean = false;

  ngOnInit(): void {
    
    this.loading = true;

    this.apiService.setNotizie();
    this.apiService.newsChanged.subscribe({
      next: (data) => {
        this.notizie = [...data];
        this.loading = false
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteNews(event: Event, news: News) {    
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare la news?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteNotizia(news.id).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {    
            this.confirmationService.close()
            this.apiService.setNotizie()
            this.apiService.message("success", "Eliminazione", "La news è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDeleteNews() {
    this.deleteNews.accept();
  }

  onAnnullaDeleteNews() {
    this.deleteNews.reject();
  }

}
